<template>
  <NuxtLink class="text-decoration-none appbartext" :to="{ path: $methods.urlPageType('WW') }">
    <SvgIconPublic :sizeIcon="iconSize" :url="icon" :badgeText="shoppingCartStore.totalProducts > 0?shoppingCartStore.totalProducts:''"/>
  </NuxtLink>
</template>

<script setup>
  import { useShoppingCartStore } from '@/layers/checkout/store/shoppingCart'
  import SvgIconPublic from "@/components/Base/SvgIconPublic.vue"

  const { $methods } = useNuxtApp()
  const shoppingCartStore = useShoppingCartStore()

  const props = defineProps({
    icon: String,
    iconSize: {
      type: [String, Number],
      default: "26",
    },
  });
</script>

